export default {
  // // items that should be currently displayed.
  // // this Array may not be fully fetched.
  // activeItems (state, getters) {
  //   return getters.activeIds.map(id => state.items[id]).filter(_ => _)
  // },
  /* eslint-disable */
  getDefaultRecordSize() {
    let size = process.env.VUE_APP_DEFAULT_SIZE || 200
    return size;
    // return 1000;
  },
  getLimitLogAuth() {
    return process.env.VUE_APP_LIMIT_LOG_AUTH || true
    // return 1000;
  },
  getDefaultDate() {
    // change from 7 days to 1 day
    return function (range_days = 6) {
      // var range_days = 7;
      const today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth()+1; 
      var yyyy = today.getFullYear();
      
      if(dd<10) {
          dd='0'+dd;
      } 

      if(mm<10) {
          mm='0'+mm;
      } 

      var end_date = yyyy+'-'+mm+'-'+dd;

      today.setDate(today.getDate() - range_days);
      dd = today.getDate();
      mm = today.getMonth()+1; 
      yyyy = today.getFullYear();
      
      if(dd<10) {
          dd='0'+dd;
      } 

      if(mm<10) {
          mm='0'+mm;
      } 

      var start_date = yyyy+'-'+mm+'-'+dd;

      return {
          from_date: start_date,
          end_date: end_date,
      };
    };
  },
  getDefaultImage() {
    // return 'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQDL6TQy3sIznqksMdJuEJwG_fthjL0oBiyEPf1_mR2KUmI-zIX&usqp=CAU';
    return process.env.VUE_APP_DEFAULT_IMAGE;
  },

  getPrefixOperator() {
  // var prefixOperator = 
    return {
          51010:'t',
          51021:'i',
          51001:'i',
          51008:'x',
          51011:'x',
          51089:'h',
          51009:'s',
          51028:'s',
    };
  },

  getTitleGlobal() {
    return (process.env.VUE_APP_ASTRO === 'true' ? 'Astro' : process.env.VUE_APP_APP_NAME);
  },
  getLogo() {
    return (process.env.VUE_APP_ASTRO === 'true' ? '/logo-astro.png' : process.env.VUE_APP_APP_LOGO);
  },
  getLogoGlobalHeader() {
    return (process.env.VUE_APP_ASTRO === 'true' ? '/logo-astro-white.png' : process.env.VUE_APP_APP_LOGO_GLOBAL_HEADER);
  },
  getFavicon() {
    return (process.env.VUE_APP_ASTRO === 'true' ? '/logo-astro.ico' : process.env.VUE_APP_APP_FAVICON);
  },
  getTerritoryVirtualMarkerRadius() {
    return (process.env.VUE_APP_TERRITORY_VIRTUAL_MARKER_RADIUS && Number.isInteger(parseInt(process.env.VUE_APP_TERRITORY_VIRTUAL_MARKER_RADIUS)) ? parseInt(process.env.VUE_APP_TERRITORY_VIRTUAL_MARKER_RADIUS) : 500);
  },

  getMeetingPointMarkerRadius() {
    return (process.env.VUE_APP_MEETING_POINT_MARKER_RADIUS && Number.isInteger(parseInt(process.env.VUE_APP_MEETING_POINT_MARKER_RADIUS)) ? parseInt(process.env.VUE_APP_MEETING_POINT_MARKER_RADIUS) : 200);
  },

  getFreqMonitoring() {
    return [
      {
          name: '5 Minutes',
          value: 'every5minutes',
          // value: '*/5 * * * *',
      },{
          name: '15 Minutes',
          value: 'every15minutes',
      },{
          name: '30 Minutes',
          value: 'every30minutes',
      },{
          name: '1 Hours',
          value: 'every1hour',
      },{
          name: '2 Hours',
          value: 'every2hours',
      },{
          name: '1 Days',
          value: 'every1day',
      },
    ]
  },
  getMaxImageSize() {
    // in MB
    if (process.env.VUE_APP_MAX_IMAGE != undefined){
      return process.env.VUE_APP_MAX_IMAGE
    } else {
      return 10
    }
  },

  getDefaultAgeRange() {
    var setDefaultAgeRange = process.env.VUE_APP_DEFAULT_AGE_RANGE || false
    var minAgeRange = process.env.VUE_APP_MIN_AGE || 0
    var maxAgeRange = process.env.VUE_APP_MAX_AGE || 200

    return {
      set: setDefaultAgeRange,
      min: minAgeRange,
      max: maxAgeRange
    }
  },
  getErrorsWording() {
    var error429title = process.env.VUE_APP_ERROR_429_TITLE || 'Too many request!'
    var error429text = process.env.VUE_APP_ERROR_429_TEXT || 'Please try again later'
    var error412title = process.env.VUE_APP_ERROR_412_TITLE || 'Number not registered as target!'
    var error412text = process.env.VUE_APP_ERROR_412_TEXT || 'Please try again later'

    return {
      error429:{
        title: error429title, 
        text: error429text
      },
      error412:{
        title: error412title, 
        text: error412text
      }
    }
  },
  getApiResp() {
    return function (lsKey) {
      let resp = null
      try {
        resp = localStorage.getItem(lsKey)
      } catch (error) {
        console.log('getApiResp:error')
        console.log(error)
      }
      return resp
    }
  },
}
